import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import Button from '../ui/Button';
import ButtonToolbar from '../ui/ButtonToolbar';
import FormControl from '../ui/FormControl';
import FormGroup from '../ui/FormGroup';
import InputGroup, { InputGroupAddon } from '../ui/InputGroup';
import { saveText } from '../../core/save';

import Tooltip from '../ui/Tooltip';
import { focusGlowStyle } from '../ui/sharedStyles';

const Filter = ({ dataField, fields = [] } = {}) => ComposedComponent =>
  class FilterComponent extends Component {
    static propTypes = {
      getField: PropTypes.func,
      saveFields: PropTypes.arrayOf(PropTypes.string),
      saveHeaders: PropTypes.arrayOf(PropTypes.string),
      saveFile: PropTypes.string,
      filterSelect: PropTypes.bool,
      selectOptions: PropTypes.arrayOf(PropTypes.object),
      onSearchFinish: PropTypes.func,
      width: PropTypes.number,
    };

    static defaultProps = {
      getField: null,
      saveFields: null,
      saveHeaders: null,
      saveFile: null,
      filterSelect: false,
      selectOptions: null,
      onSearchFinish: null,
    };

    constructor(props) {
      super(props);
      const { filterSelect, selectOptions } = props;

      this.state = {
        filteredData: props[dataField],
        selectedFilterType: filterSelect ? selectOptions[0] : null,
      };

      this._onFilterChange = this._onFilterChange.bind(this);
      this._onSortChange = this._onSortChange.bind(this);
      this._getFieldValue = this._getFieldValue.bind(this);
      this.updateFilteredData = this.updateFilteredData.bind(this);

      this._filterText = null;
      this._sortOrder = 1;
      this._sortField = null;
    }

    componentDidUpdate(prevProps, prevState) {
      const { selectedFilterType } = this.state;

      // eslint-disable-next-line react/destructuring-assignment
      if (this.props[dataField] !== prevProps[dataField]) {
        // eslint-disable-next-line react/destructuring-assignment
        this.updateFilteredData(this.props[dataField]);
      }
      if (selectedFilterType !== prevState.selectedFilterType) {
        this._onChange();
      }
    }

    updateFilteredData(filteredData) {
      this.setState({ filteredData });
    }

    selectFilterType(filter) {
      this.setState({ selectedFilterType: filter });
    }

    _onFilterChange(e) {
      this._filterText = e.target.value.toLowerCase().trim();
      this._onChange();
    }

    _getFieldValue(row, field) {
      const { getField } = this.props;
      if (getField && typeof getField === 'function')
        return getField(row, field);
      return row[field];
    }

    _onSortChange(e, order) {
      if (order) this._sortOrder = order;
      else this._sortOrder = 1;
      this._sortField = e;
      this._onChange();
    }

    _onChange() {
      const { onSearchFinish } = this.props;
      const { selectedFilterType } = this.state;
      // eslint-disable-next-line react/destructuring-assignment
      const data = this.props[dataField];
      const filterBy = this._filterText;

      const size = data.length;
      let filtered = [];
      let searchFields = fields;
      if (selectedFilterType) searchFields = [selectedFilterType.value];

      if (filterBy && filterBy !== '') {
        for (let index = 0; index < size; index += 1) {
          for (let idx = 0; idx < searchFields.length; idx += 1) {
            const value = this._getFieldValue(data[index], searchFields[idx]);
            if (value) {
              const match = value
                .toString()
                .toLowerCase()
                .includes(filterBy);
              if (match) {
                filtered.push(data[index]);
                break;
              }
            }
          }
        }
      } else {
        filtered = data.slice(0);
      }

      if (this.sortField) {
        filtered = filtered.sort((a, b) => {
          const fieldValue =
            this._getFieldValue(a, this._sortField) >
            this._getFieldValue(b, this._sortField)
              ? 1
              : 0;
          const val =
            this.getFieldValue(a, this._sortField) <
            this._getFieldValue(b, this._sortField)
              ? -1
              : fieldValue;
          return val * this._sortOrder;
        });
      }
      if (onSearchFinish) onSearchFinish();
      this.setState({
        filteredData: filtered,
      });
    }

    _getText(index) {
      const { saveFields } = this.props;
      const { filteredData } = this.state;

      let text = '';
      saveFields.forEach((f, idx, a) => {
        const value = this._getFieldValue(filteredData[index], f);
        text += (value || '') + (idx + 1 < a.length ? ',' : '');
      });
      return text;
    }

    _asText() {
      const { saveHeaders } = this.props;
      const { filteredData } = this.state;

      let text = `${saveHeaders.join(',').toUpperCase()}\n`;
      for (let i = 0; i < filteredData.length; i += 1) {
        text += this._getText(i);
        text += '\n';
      }
      return text;
    }

    render() {
      const {
        saveFields,
        filterSelect,
        saveFile,
        selectOptions,
        width,
      } = this.props;

      const { filteredData } = this.state;

      const downloadWidth = saveFields ? 40 : 0;
      const selectWidth = filterSelect ? 110 : 0;
      const formWidth = width ? width - (downloadWidth + selectWidth) : '100%';

      return (
        <div>
          <div style={{ width }}>
            <FormGroup
              style={{
                width: `${width ? `${formWidth.toString()}px` : formWidth}`,
                height: '38px',
                display: 'inline-block',
                verticalAlign: 'middle',
                margin: 0,
              }}
            >
              <InputGroup style={{ height: '38px' }}>
                <InputGroupAddon>
                  <i className="fa fa-search" />
                </InputGroupAddon>
                <FormControl
                  style={{ height: '38px', borderRadius: '0 4px 4px 0' }}
                  onChange={this._onFilterChange}
                  type="text"
                  placeholder="Search"
                />
              </InputGroup>
            </FormGroup>

            {saveFields && (
              <ButtonToolbar
                style={{ display: 'inline-block', verticalAlign: 'middle' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 4,
                    alignItems: 'center',
                  }}
                >
                  <Button
                    style={{ height: '38px' }}
                    onClick={() => {
                      saveText(this._asText(), `${saveFile}.txt`);
                    }}
                  >
                    <Tooltip text="Download data">
                      <i className="fa fa-download" />
                    </Tooltip>
                  </Button>
                </div>
              </ButtonToolbar>
            )}
            {filterSelect && (
              <div
                style={{
                  width: selectWidth,
                  display: 'inline-block',
                  verticalAlign: 'middle',
                }}
              >
                <Select
                  isSearchable={false}
                  onChange={filter => this.selectFilterType(filter)}
                  defaultValue={selectOptions[0]}
                  options={selectOptions}
                  styles={{
                    control: (selectStyles, state) => ({
                      ...focusGlowStyle.control(selectStyles, state),
                      zIndex: 100,
                    }),
                    menu: selectStyles => ({
                      ...selectStyles,
                      zIndex: 100,
                    }),
                  }}
                />
              </div>
            )}
          </div>
          <ComposedComponent
            {...this.props}
            {...{ [dataField]: filteredData }}
            onSort={this._onSortChange}
          />
        </div>
      );
    }
  };

export default Filter;
